import { render, staticRenderFns } from "./AppointmentRecord.vue?vue&type=template&id=0f1ea854&scoped=true&"
import script from "./AppointmentRecord.vue?vue&type=script&lang=js&"
export * from "./AppointmentRecord.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentRecord.vue?vue&type=style&index=0&id=0f1ea854&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1ea854",
  null
  
)

export default component.exports